import packageCfg from '@old/package.config' with { type: 'json' };

export const SILOREAL_WEBSITE_VERSION = packageCfg.version;
